import { Card } from "PFComponents/card";
import { Import } from "PFTypes";

import css from "./imports_history_page.module.scss";
import { ImportHistoryTableProps, ImportsHistoryTable } from "./parts";
import { ImportBaseWithState } from "./parts/imports_history_table/hooks/use_columns_generator";

export const ImportHistoryPage = <T extends ImportBaseWithState = Import>(
  params: ImportHistoryTableProps<T>
) => (
  <Card shadowVariant="inset" className={css.card}>
    <ImportsHistoryTable<T> {...params} />
  </Card>
);
